const Roles = {
  AGENCY : 'agency',
  ADMIN  : 'admin'
}

module.exports = {
  Roles
}